import axios, { AxiosInstance } from "axios";
import AuthStore from "../Store/AuthStore";
import { TokenType } from "../Types/Auth";
import { URLHOSTBACKEND } from "../Const/envConst";

// const API_ENDPOINT = "http://localhost:3000/api";
const API_ENDPOINT =
	process.env.NODE_ENV === "production" ? URLHOSTBACKEND : "";

const apiConfig = (): AxiosInstance => {
	const authToken: TokenType = AuthStore.token;
	let headers;
	if (authToken) {
		headers = {
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
			token: authToken,
		};
	} else {
		headers = {
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
		};
	}

	return axios.create({
		baseURL: API_ENDPOINT,
		headers: headers,
	});
};

export default apiConfig;
